import { isAiConfigAvailableForUser } from 'shared-helpers/aiTools';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { ProfileCompetencyMapping } from '.';
import { Box } from 'components/common/box';

import type { GetCompetencyMappingRes } from 'shared-types/responses';
import { LinkButton } from 'components/common';

const ProfileSummaryCompetencyMapping = () => {
  const { messages, serverConfig, user: loggedInUser } = useReduxState();

  const competencyMappingEnabled = isAiConfigAvailableForUser({
    requiredAiExtraServerConfig: 'aiExtraCompetencyMapping',
    requireAiToolsPermission: false,
    serverConfig,
    user: loggedInUser
  });

  const { data, loading } = useApiData<GetCompetencyMappingRes>({
    onlyIf: Boolean(competencyMappingEnabled),
    url: '/admin/competency-mapping-latest/'
  });

  if (!competencyMappingEnabled) return null;

  return (
    <div className="mapping" style={{ marginBottom: 30 }}>
      <Box title={messages.competencyMapping}>
        <div className="inner">
          <ProfileCompetencyMapping />

          {data?.mapping ? (
            <LinkButton
              category="light"
              href={`/profile/competency-mappings/${data.mapping.id}`}
              icon="medal"
              text={messages.competencyMappingViewPrevious}
            />
          ) : null}
        </div>
      </Box>

      <style jsx>{`
        .inner {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          justify-content: space-between;
        }
      `}</style>
    </div>
  );
};

export default ProfileSummaryCompetencyMapping;
